function requiredEnv(name: string, value: string | undefined): string {
  if (!value) throw new Error(`Missing required environment variable: ${name}`);
  return value;
}

export const env = {
  apiUrl: requiredEnv('VITE_API_URL', import.meta.env.VITE_API_URL),
  auth0Domain: requiredEnv('VITE_AUTH0_DOMAIN', import.meta.env.VITE_AUTH0_DOMAIN),
  auth0ClientId: requiredEnv('VITE_AUTH0_CLIENTID', import.meta.env.VITE_AUTH0_CLIENTID),
  auth0Audience: requiredEnv('VITE_AUTH0_AUDIENCE', import.meta.env.VITE_AUTH0_AUDIENCE),
  gaMeasurementId: requiredEnv('VITE_GA_MEASUREMENT_ID', import.meta.env.VITE_GA_MEASUREMENT_ID),
  // Public marketing site the admin links to when copying content for social.
  // Optional so the admin app still boots where it is not set.
  publicSiteUrl: (import.meta.env.VITE_PUBLIC_SITE_URL ?? 'https://colbrensolutions.com').replace(/\/+$/, ''),
} as const;
